/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect, Fragment} from 'react'
import {useIntl} from 'react-intl'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Dropdown, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import {Link, useNavigate} from 'react-router-dom'
import JobServices from '../../../../services/job'
import useServices from '../../../../utils/hooks/useServices'
import useDebounce from '../../../../utils/hooks/useDebounce'
import MasterServices from '../../../../services/master'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../utils/helpers/FormGenerator'

let active = 1
let items: any = []
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  )
}

const heads = [
  {
    name: '',
    label: 'Nama Alumni',
  },
  // {
  //   name: '',
  //   label: 'Tanggal Daftar',
  // },
  {
    name: '',
    label: 'Email',
  },
  // {
  //   name: '',
  //   label: 'Username',
  // },
  {
    label: 'Status',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const inputs = [
  {
    name: 'name',
    label: 'Nama Alumni',
    type: '',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
  {
    name: 'description',
    label: 'Deskripsi Alumni',
    type: '',
    validation: {},
    col: 12,
    options: [],
    additional: '',
  },
]

const CompanyPage: FC = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [isEdit, setIsEdit] = useState(false)
  const [show, setShow] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [formValue, setFormValue] = useState<any>({status: '', company_id: ''})
  const [submit, setSubmit] = useState(false)
  const [selected, setSelected] = useState<any>([])
  const [counter, setCounter] = useState(1)
  const [data, loading, empty, refresh, isError, setLoading] = useServices(
    MasterServices.getAlumni,
    {
      ...query,
      page: pagination.page,
      sort_field: 'created_at',
      per_page: pagination.per_page,
      status: [4, 6],
      roles: ['alumni'],
    },
    []
  )
  const paginator: any = usePagination({
    totalCount: data?.data?.total,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  useEffect(() => {
    refresh()
    generateTotalPage(pagination.total_page)
  }, [pagination.per_page, pagination.page])

  useDebounce(refresh, 250, [query.q, query.sort_order])

  const StatusComponent = (type: string, obj?: any) => {
    if (type === 'Ditolak') {
      return (
        <Button className='shadow-none btn btn-sm btn-outline btn-outline-danger' variant='outline'>
          {type}
        </Button>
      )
    }
    return (
      <Button className='shadow-none btn btn-sm btn-outline btn-outline-success' variant='outline'>
        {type}
      </Button>
    )
  }

  const handleApprove = async () => {
    try {
      setSubmit(true)
      await MasterServices.approveCompany(formValue)
      toast.success('Proses berhasil dilakukan')
      refresh()
    } catch (error) {
    } finally {
      setSubmit(false)
    }
  }

  const toggle = () => {
    if (show) {
      setFormValue({})
    }
    setShow(!show)
  }

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      if (total < 4) {
        newTotal.push(total + 1)
      } else if (total === 8) {
        newTotal.push('...')
        newTotal.push(totalPage)
      }
    }
    return newTotal
  }
  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const handleDelete = async (id: any) => {
    try {
      if (window.confirm('Yakin ingin menghapus Alumni ?')) {
        setLoading(true)
        await MasterServices.deleteCompany(id)
        toast.success(`Alumni Berhasil Dihapus`)
        refresh()
      }
    } catch (error) {
    }
  }

  const handleCheck = (param: any) => {
    let newSelected: any = selected || []

    if (typeof param === 'number') {
      const check = selected?.filter((f: any) => param === f.user_id)
      if (check.length < 1) {
        newSelected.push({
          user_id: param,
          status: 1,
        })
      } else {
        newSelected = selected?.filter((f: any) => f.user_id !== param)
      }
    }

    if (param === 'all') {
      if (selected?.length > 0) {
        newSelected = []
      } else {
        data?.data?.data?.forEach((item: any) => {
          return newSelected.push({
            user_id: item.users_id,
            status: 1,
          })
        })
      }
    }
    setSelected(newSelected)
    setCounter((val) => val + 1)
  }

  const handleChangeStatus = async () => {
    try {
      if (window.confirm('Yakin ingin Mengubah status Alumnii ?')) {
        setLoading(true)
        for (let index = 0; index < selected.length; index++) {
          const element = selected[index]
          await MasterServices.approveCompany(element)
        }
        toast.success(`Status Alumni Berhasil Diperbarui`)
      }
    } catch (error) {
    } finally {
      refresh()
    }
  }

  const handleChangeStatusSingle = async (id: any, status: any) => {
    try {
      if (window.confirm('Yakin ingin Mengubah status Alumni ?')) {
        setLoading(true)
        await MasterServices.approveCompany({status: status, user_id: id})
        toast.success(`Status Alumni Berhasil Diperbarui`)
      }
    } catch (error) {
    } finally {
      refresh()
    }
  }
  return (
    <>
      <div className='row'>
        <Modal show={show} onHide={toggle} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>Verifikasi Alumni</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={12}>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    onChange={(e: any) => setFormValue({...formValue, status: e.target.value})}
                  >
                    {[
                      {name: 'Verifikasi 1', value: '0'},
                      {name: 'Aktif', value: '1'},
                      {name: 'Ditolak', value: '2'},
                      {name: 'Tutup', value: '3'},
                    ].map((item, key) => {
                      return (
                        <option
                          key={key}
                          value={item.value}
                          selected={formValue.status === item.value}
                        >
                          {item.name}
                        </option>
                      )
                    })}
                  </Form.Select>
                </Col>
              </Row>
              <Modal.Footer>
                <Button variant='secondary' onClick={toggle} disabled={submit}>
                  Batalkan
                </Button>
                <Button variant='primary' disabled={submit} onClick={handleApprove}>
                  {submit ? 'Loading' : 'Simpan'}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>
        <div className='col-md-12'>
          <div className='card-custom' style={{paddingBottom: '80px'}}>
            <Row>
              <Col md={{span: 4}}>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) => setQuery({...query, q: e.target.value})}
                />
              </Col>
              <Col md={{span: 2, offset: 6}}>
                <Form.Select
                  aria-label='Default select example'
                  className='mr-8'
                  onChange={(e) => {
                    setQuery({...query, sort_order: e.target.value})
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </Form.Select>
              </Col>
            </Row>
            {selected.length > 0 && (
              <Button onClick={handleChangeStatus} type='button' className='mt-8'>
                Approve data terpilih ?
              </Button>
            )}
            <Row md={12} className='mt-8'>
              <Table responsive className='table-striped align-middle'>
                <thead>
                  <tr>
                    <th>
                      <Form.Check
                        onClick={() => handleCheck('all')}
                        checked={data?.data?.data.length === selected.length}
                      />
                    </th>
                    {heads.map((item, index) => (
                      <th key={index} style={{maxWidth: item.label == 'Aksi' ? '100px' : ''}}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.data?.data?.length === 0 && !loading && (
                    <tr>
                      <td colSpan={5} align='center'>
                        Tidak ada Data
                      </td>
                    </tr>
                  )}
                  {loading ? (
                    <tr>
                      <td colSpan={5} align='center'>
                        <Spinner
                          animation='border'
                          role='status'
                          style={{height: '100px', width: '100px'}}
                        />
                      </td>
                    </tr>
                  ) : (
                    counter &&
                    data.data?.data?.map((item: any, key: any) => {
                      return (
                        <tr key={key}>
                          <td>
                            {
                              <Form.Check
                                value={item.users_id}
                                onChange={() => handleCheck(item.users_id)}
                                checked={
                                  selected.filter((f: any) => f.user_id === item.users_id).length >
                                  0
                                    ? true
                                    : false
                                }
                              />
                            }
                          </td>
                          <td>
                            <Link
                              to={`/crafted/pages/profile/basic-overview?alumni=${item.id_hash}`}
                            >
                              {item.fullname}
                            </Link>
                          </td>
                          {/* <td>{new Date(item.created_at).toLocaleDateString() || '-'}</td> */}
                          <td>{item.email || '-'}</td>
                          {/* <td>{item.users_username || '-'}</td> */}
                          <td>
                            {StatusComponent(
                              item.users_status == '4' ? 'Ditolak' : item.status_approval
                            )}
                          </td>
                          <td>
                            <Dropdown>
                              <Dropdown.Toggle
                                id='dropdown-basic'
                                className='btn btn-primary btn-sm'
                              >
                                {'  '}
                                Aksi
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  onClick={() => {
                                    // setFormValue({
                                    //   id: item.companies_id,
                                    //   name: item.companies_name,
                                    //   description: item.companies_description,
                                    // })
                                    // toggle()
                                    navigate(
                                      `/crafted/pages/profile/basic-overview?alumni=${item.id_hash}`
                                    )
                                  }}
                                >
                                  Lihat
                                </Dropdown.Item>
                                {item.users_status != '4' && (
                                  <Fragment>
                                    <Dropdown.Item
                                      onClick={() => handleChangeStatusSingle(item.users_id, '1')}
                                    >
                                      Approve
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => handleChangeStatusSingle(item.users_id, '0')}
                                    >
                                      Reject
                                    </Dropdown.Item>
                                  </Fragment>
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      )
                    })
                  )}
                </tbody>
              </Table>
            </Row>
            <Row>
              <Col md={6}>
                {data?.data?.data?.length > 0 && !loading && (
                  <div style={{float: 'left'}}>
                    <Dropdown>
                      <Dropdown.Toggle className='btn btn-sm'>
                        {pagination.per_page}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {[10, 25, 50, 100].map((item: any) => (
                          <Dropdown.Item
                            key={item}
                            href='#/action-1'
                            onClick={() => onChangePerPage(item)}
                            disabled={pagination.per_page === item}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </Col>
              <Col md={6}>
                <div style={{float: 'right'}}>
                  {!loading && (
                    <Pagination className='btn-sm'>
                      {paginator?.map((item: any) => {
                        return (
                          <Pagination.Item
                            className='btn-sm'
                            key={item}
                            active={item === pagination.page}
                            onClick={() => onChangePerPage(pagination.per_page, item)}
                            disabled={item === '...'}
                          >
                            {item}
                          </Pagination.Item>
                        )
                      })}
                    </Pagination>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

const UserVerification: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Verifikasi Alumni
      </PageTitle>
      <CompanyPage />
    </>
  )
}

export default UserVerification
